import isEmail from 'validator/lib/isEmail';

export const validateRequiredField = (value: string | undefined): string | boolean => {
  return !!value?.trim() || 'Complete field to continue';
};

export const validateEmail = (value: string | undefined): string | boolean => {
  if (!value) return true; // Email is optional
  return isEmail(value) || 'Invalid email address';
};

/**
 * Extracts valid (non-empty) email addresses from an array of email objects.
 * Filters out the empty strings and trims whitespace from valid emails.
 * @param emails Array of objects with email property
 * @returns Array of trimmed email strings, or undefined if no valid emails found
 * @example
 * extractValidEmails([{ email: 'user1@example.com' }, { email: '  ' }, { email: 'user3@example.com' }])
 * // returns ['user1@example.com', 'user3@example.com']
 */
export const extractValidEmails = (emails?: { email: string }[]): string[] | undefined => {
  if (!emails) {
    return undefined;
  }

  const validEmails = emails.filter(item => item.email.trim() !== '').map(item => item.email.trim());

  return validEmails.length > 0 ? validEmails : undefined;
};
